export default __webpack_public_path__ + "static/media/app-screens-v2-67-2_09.4e7d4227.jpg";